import { render, staticRenderFns } from "./LicitacaoFornecedorDocumentos.vue?vue&type=template&id=3dd6736f"
import script from "./LicitacaoFornecedorDocumentos.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorDocumentos.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorDocumentos.vue?vue&type=style&index=0&id=3dd6736f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports